module.exports = __webpack_public_path__ + "static/media/AdobeClean-SemiCn_1707995378386.cf0ca097.otf";